import type { ChapterContent, FirstGameStep } from '../../types';

/**
 * Weather Machine — Content Rewrite 3.0
 * Source: docs/perfect-quality/02_NOWE_GRY_PELNE_INSTRUKCJE/10_WEATHER_MACHINE_PELNA_INSTRUKCJA.md
 * No expansions in local source → no expansion menu chapters.
 * Icon-only costs/rewards and player-count component catalogues remain PARTIAL blockers.
 */
export const weatherMachineChapters: ChapterContent[] = [
  {
    title: '1. Cel gry i granice tej instrukcji',
    content: [
      {
        type: 'warning',
        text: 'Ten podręcznik uczy przepływu gry Weather Machine z lokalnego szkicu Perfect Quality. Konkretne koszty i nagrody drukowane wyłącznie ikonami na kaflach, torach i planach eksperymentów nie są tu katalogowane — odczytujesz je z komponentów przy stole. Nie dopowiadaj wartości z pamięci.',
      },
      {
        type: 'heading',
        text: 'Co robisz i po co',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gracze są naukowcami współpracującymi z profesorem Lativem nad maszyną kontrolującą pogodę. Zdobywacie punkty klimatu przez badania, eksperymenty, prototypy, publikacje, cytowania, dotacje i udział w naprawianiu skutków maszyny. Nie wygrywa ten, kto „zrobi najwięcej akcji”, lecz ten, kto spójnie łączy warsztat, kupony, wkład w eksperymenty i wyniki naukowe.',
      },
      {
        type: 'heading',
        text: 'Kiedy gra się kończy',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Partia nie trwa nieskończenie. Kończy się, gdy zostanie uruchomiony jeden z głównych sygnałów końca — między innymi przyznanie Nagrody Nobla, zapełnienie odpowiedniego obszaru Rządu lub R&D albo wyczerpanie eksperymentów. Po sygnale nie zrywasz stołu natychmiast: dokańczacie wymaganą część gry według oficjalnej procedury, a dopiero potem punktujecie końcowo.',
      },
      {
        type: 'heading',
        text: 'Mini-przykład przy stole',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Anna ma już badania i chce publikować. Najpierw sprawdza, czy naukowiec jest w Laboratorium Lativa i czy spełnia wymagania publikacji. Publikacja daje jej punkty i otwiera innym drogę do cytowań. Równolegle Bartek wypełnia pola Rządu sprzedażą części — jeśli obszar Rządu się zapełni, wszyscy przygotowują się do procedury końca, a nie do „jeszcze jednej swobodnej rundy bez limitu”.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: traktowanie sygnału końca jak natychmiastowego przerwania gry. Sygnał uruchamia dokończenie, nie kasuje bieżącego stanu bez procedury.',
      },
      {
        type: 'tip',
        text: 'Wyjątek i odsyłacz: dokładna kolejność dokończenia dla każdego triggera jest oznaczona do weryfikacji względem polskiego wydania. Procedury lokalizacji i faz opisują kolejne rozdziały; punktowanie — rozdział 13.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Cel: punkty klimatu przez silnik naukowy i udział w maszynie pogodowej. P: Czy ta instrukcja zastępuje ikony na kaflach? O: Nie — ikony odczytujesz z komponentów. P: Czy brak dodatku w menu oznacza, że gra ma dodatek w aplikacji? O: Lokalny szkic nie opisuje gotowych dodatków; nie wymyślaj ich.',
      },
    ],
  },
  {
    title: '2. Cztery lokalizacje: mapa decyzji',
    content: [
      {
        type: 'heading',
        text: 'Co widzisz na planszy i dlaczego',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Cała gra krąży wokół czterech miejsc. Naukowiec gracza wskazuje, w której lokalizacji wykonujesz akcję w danej turze. Nie „odwiedzasz wszystkich naraz”: najpierw przenosisz naukowca legalnie, potem wykonujesz jedną akcję miejsca, a dopiero potem — jeśli masz prawo — akcje dodatkowe.',
      },
      {
        type: 'heading',
        text: 'Zaopatrzenie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Tu budujesz zaplecze. Rozbudowujesz warsztat, konstruujesz boty, zdobywasz inicjatywę oraz pobierasz albo zwracasz chemikalia. Zaopatrzenie nie wygrywa partii samo, ale bez pojemności warsztatu i botów nie utrzymasz wkładu w eksperymentach.',
      },
      {
        type: 'heading',
        text: 'Rząd',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Tu współpracujesz z administracją: sprzedajesz części maszyny, zabezpieczasz dotacje, rozwijasz finansowanie i realizujesz wymagania Rządu. Zapełnienie odpowiedniego obszaru Rządu może uruchomić sygnał końca gry.',
      },
      {
        type: 'heading',
        text: 'Laboratorium Lativa',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'To serce wspólnych eksperymentów. Dostarczasz boty i chemikalia, przygotowujesz eksperyment, publikujesz artykuły i korzystasz z cytowań. Po wejściu do Laboratorium możesz przesunąć Lativa zgodnie z regułą tej lokalizacji — to nie jest ozdoba, tylko element warunków uruchomienia eksperymentu w Fazie B.',
      },
      {
        type: 'heading',
        text: 'Badania i Rozwój (R&D)',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Tu rozwijasz technologię: prowadzisz badanie, osiągasz przełom, budujesz prototyp i przygotowujesz naukowy wkład do przyszłych eksperymentów. Zapełnienie odpowiedniego obszaru R&D również może uruchomić koniec gry.',
      },
      {
        type: 'heading',
        text: 'Przykład wyboru lokalizacji',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Masz wolne boty, ale brakuje chemikaliów do wkładu w aktywną gałąź pogody. Idziesz do Zaopatrzenia po chemikalia albo po rozbudowę pojemności, a nie od razu do Laboratorium „na zapas”. Jeśli natomiast masz badania i chcesz zamknąć prototyp, R&D jest właściwym celem ruchu naukowca w tej turze.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: myślenie, że lokalizacja to tylko „temat tury”. Lokalizacja wyznacza legalny zestaw akcji; bez ruchu naukowca nie wykonujesz akcji innego miejsca.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: dokładny przebieg tury i podróż naukowca są w rozdziale 5; szczegóły każdej lokalizacji — w rozdziałach 8–10. Diagram czterech miejsc: Zaopatrzenie → Rząd → Laboratorium → R&D, a naukowiec stoi zawsze w jednym z nich.',
      },
      {
        type: 'diagram',
        diagramId: 'procedure-flow',
        alt: 'Cztery lokalizacje Weather Machine',
        fallbackText: 'Schemat: naukowiec wskazuje jedną z czterech lokalizacji — Zaopatrzenie, Rząd, Laboratorium Lativa albo R&D — i tylko tam wykonujesz akcję lokalizacji w tej turze.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Cztery lokalizacje dzielą pracę: zaplecze, administracja, eksperymenty, rozwój. P: Czy mogę w jednej turze działać w dwóch lokalizacjach? O: Nie przez samą akcję lokalizacji — najpierw przenosisz naukowca, potem jedną akcję miejsca. P: Czy Laboratorium i Faza B to to samo? O: Nie; Laboratorium przygotowujesz w turach, a eksperyment rozliczacie wspólnie w Fazie B.',
      },
    ],
  },
  {
    title: '3. Zasoby i elementy gry',
    content: [
      {
        type: 'heading',
        text: 'Co trzymasz i do czego służy',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Weather Machine miesza kilka rodzajów elementów. Naukowiec wskazuje lokalizację. Boty wykonują pracę i zajmują miejsca na projektach. Chemikalia mają typy/kolory i są wymagane przez eksperymenty oraz projekty. Części maszyny wytwarzasz i sprzedajesz — zwłaszcza w Rządzie. Kupony są wyspecjalizowaną walutą akcji: kolor lub symbol mówi, gdzie wolno je wydać. Żetony badań rozwijają dziedziny i otwierają publikacje. Kafle warsztatu zwiększają pojemność i możliwości. Znaczniki finansowania oraz inicjatywy pokazują postęp na torach. Plany eksperymentów, prototypów i publikacji niosą konkretne wymagania i nagrody — często wyłącznie ikonami.',
      },
      {
        type: 'heading',
        text: 'Kiedy którego zasobu używasz',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Kupony wydajesz przy akcji lokalizacji. Botów i chemikaliów nie zastąpisz kuponem, chyba że konkretna ikona wyraźnie na to pozwala. Limit przechowywania wynika z planszy gracza i warsztatu; nadwyżka przepada, jeśli efekt nie daje innego rozwiązania. Bot umieszczony na planszy nie siedzi już w rezerwie — wraca dopiero w chwili wskazanej przez eksperyment, koniec rundy albo efekt.',
      },
      {
        type: 'heading',
        text: 'Przykład mieszania zasobów',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Chcesz dołożyć wkład do eksperymentu. Masz kupon Laboratorium, jednego bota w rezerwie i chemikalia właściwego koloru. Kupon opłaca akcję, bot i chemikalia spełniają wymaganie pola. Jeśli masz tylko kupon, a brakuje bota, akcja nie „domyka się” samym kuponem.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: używanie kuponu jak uniwersalnego zasobu zamiast botów lub chemikaliów. Kupon płaci za czynność; nie zastępuje brakującego wkładu materiałowego.',
      },
      {
        type: 'tip',
        text: 'Wyjątek: uniwersalny kupon może zastąpić wskazany typ tylko zgodnie z ikoną na komponencie. Szczegóły kuponów — rozdział 6; warsztatu i botów — rozdział 7; chemikaliów — tamże.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Każdy zasób ma rolę: pozycja, praca, materiał, waluta akcji, badania, pojemność, tory, plany. P: Czy zwiększenie limitu warsztatu daje od razu boty? O: Nie — limit to pojemność, nie automatyczna dostawa. P: Czy bot wraca natychmiast po położeniu? O: Nie, wraca według pola, fazy eksperymentu lub efektu.',
      },
    ],
  },
  {
    title: '4. Przygotowanie',
    content: [
      {
        type: 'heading',
        text: 'Co przygotowanie ustala i dlaczego',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Przygotowanie buduje wspólny stan: lokalizacje, wystawki, maszynę pogodową, Lativa, asystenta, inicjatywę oraz prywatne zaplecze każdego gracza. Zrób je w całości przed pierwszą turą — inaczej Faza B nie będzie miała sensu, bo brakuje gałęzi pogody, eksperymentów albo znaczników.',
      },
      {
        type: 'heading',
        text: 'Kolejność kroków',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Rozłóż planszę główną i plansze eksperymentów.',
          'Przygotuj cztery lokalizacje i ich wystawki.',
          'Rozłóż kafle badań, prototypów, publikacji i dotacji.',
          'Przygotuj maszynę pogodową, regiony oraz typy pogody.',
          'Ustaw profesora Lativa, asystenta i znaczniki inicjatywy.',
          'Każdy gracz bierze planszę, naukowca, boty, znaczniki i zasoby startowe.',
          'Rozdaj lub wybierz cele i elementy początkowe zgodnie z liczbą graczy.',
          'Zablokuj pola niedostępne przy mniejszej liczbie graczy.',
          'Ustal pierwszego gracza.',
        ],
      },
      {
        type: 'warning',
        text: '[DO WERYFIKACJI] Dokładne liczby komponentów startowych oraz blokady pól dla 2/3/4 graczy muszą pochodzić z polskiego wydania. Aplikacja nie wymyśla tych liczb.',
      },
      {
        type: 'heading',
        text: 'Przykład kontroli gotowości',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Przed pierwszą turą sprawdźcie: cztery lokalizacje mają wystawki, maszyna pogodowa i typ pogody są ustawione, Lativ i asystent stoją na wskazanych miejscach, każdy ma naukowca i startowe zaplecze, a pola niedostępne dla waszej liczby graczy są zasłonięte. Dopiero wtedy ustalacie kolejność i zaczynacie Fazę A.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: rozpoczęcie gry bez zablokowania pól zależnych od liczby graczy albo bez przygotowania maszyny i asystenta — Faza B wtedy nie ma kompletnych warunków.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: po setupie przejdź do rozdziału 5 (rytm rundy). Startowa pojemność warsztatu i botów wraca w rozdziale 7.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gotowa partia ma plansze, wystawki, pogodę, Lativa/asystenta, graczy i blokady liczby graczy. P: Czy wolno zacząć bez celów startowych? O: Nie — rozdajcie lub wybierzcie je zgodnie z liczbą graczy. P: Skąd brać dokładne liczby startowe? O: Z polskiego wydania; tu są oznaczone do weryfikacji.',
      },
    ],
  },
  {
    title: '5. Runda i Faza A — tura gracza',
    content: [
      {
        type: 'heading',
        text: 'Trzy fazy rundy',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Każda runda ma trzy fazy. Faza A: tury graczy. Faza B: uruchomienie eksperymentu. Faza C: koniec rundy. Ta kolejność wyjaśnia spory przy stole: nagród eksperymentu nie wypłacasz w środku czyjejś tury, a inicjatywę i odświeżenia domykasz dopiero w Fazie C — o ile lokalna procedura tak wskazuje.',
      },
      {
        type: 'diagram',
        diagramId: 'procedure-flow',
        alt: 'Przebieg rundy Weather Machine',
        fallbackText: 'Schemat rundy: A — tury graczy (opcjonalny kafel → ruch naukowca → akcja lokalizacji → akcje dodatkowe); B — sprawdzenie i uruchomienie eksperymentu; C — odświeżenie, inicjatywa, sygnały końca.',
      },
      {
        type: 'heading',
        text: 'Krok 1. Opcjonalnie użyj jednego kafla',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Na początku swojej tury możesz wykorzystać jeden posiadany kafel Dotacji albo Inwestycji, jeśli spełniasz warunki. Sam kafel określa efekt, koszt oraz to, czy jest odrzucany lub odwracany. Nie musisz go używać — jeśli jest opcjonalny, pominięcie jest legalne. Jeśli go używasz, zrób to w tym kroku, a nie „przy okazji” w środku akcji lokalizacji.',
      },
      {
        type: 'heading',
        text: 'Krok 2. Podróż — przenieś naukowca',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Podróż naukowca to bramka legalności całej tury: dopiero po legalnym ruchu (albo legalnym pozostaniu) wolno wykonać akcję lokalizacji. Przenieś naukowca do legalnej lokalizacji. Zasady ruchu na planszy i efektach mogą ograniczać pozostanie w miejscu albo wybór kolejnej lokalizacji — odczytuj je z komponentów, nie zakładaj swobodnego skoku między dowolnymi miejscami. Po wejściu do Laboratorium Lativa możesz przesunąć Lativa zgodnie z regułą tej lokalizacji; to część podróży do Laboratorium, nie osobna „bonusowa akcja poza turą”.',
      },
      {
        type: 'paragraph',
        text: 'Pozostanie w tej samej lokalizacji jest dozwolone tylko wtedy, gdy reguła ruchu albo efekt specjalny na to pozwala. Jeśli reguła wymaga zmiany miejsca, a Ty zostajesz „bo wygodniej”, akcja lokalizacji jest nielegalna. Po zakończeniu ruchu naukowiec wskazuje dokładnie jedno miejsce — i tylko tam rozliczasz krok 3.',
      },
      {
        type: 'heading',
        text: 'Krok 3. Wykonaj akcję lokalizacji',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Wykonaj jedną z dostępnych akcji w lokalizacji, w której stoi naukowiec. Opłać koszt kuponami i zasobami, umieść boty albo znaczniki tam, gdzie wymaga tego plansza. Akcja musi być wykonalna w całości — nie zaczynaj jej, jeśli nie stać cię na wymagania.',
      },
      {
        type: 'heading',
        text: 'Krok 4. Akcje dodatkowe i badania',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Rozpatrz dozwolone akcje dodatkowe oraz efekty warsztatu, torów i kafli. Jeśli wykonałeś badanie, umieść żetony badań na odpowiednich obszarach. Nie wolno przerwać nierozdzielnego efektu inną akcją, chyba że symbol oznacza akcję darmową — wtedy efekt kafla albo ikony mówi, kiedy wolno wstawić dodatkową czynność.',
      },
      {
        type: 'heading',
        text: 'Przykład pełnej tury',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Anna używa kafla inwestycji. Następnie przenosi naukowca z Zaopatrzenia do R&D — to jej podróż w tej turze. Wydaje właściwy kupon, wykonuje badanie i umieszcza żeton w dziedzinie potrzebnej do prototypu. Dzięki efektowi warsztatu może następnie wykonać akcję dodatkową, ale nie przerywa nią umieszczania żetonu. Na końcu aktualizuje swój stan i przekazuje turę.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: wstawianie akcji dodatkowej w środek nierozdzielnego efektu, pomijanie kroku kafla i „doklejanie” go po ruchu naukowca, albo wykonywanie akcji w lokalizacji, do której naukowiec nie dotarł legalnie.',
      },
      {
        type: 'tip',
        text: 'Odsyłacze: kupony — rozdział 6; lokalizacje — 8–10; Faza B i maszyna pogodowa — rozdział 11. Pozostanie w tej samej lokalizacji jest legalne tylko gdy reguła ruchu albo efekt specjalny na to pozwala.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Tura: opcjonalny kafel → podróż naukowca → jedna akcja lokalizacji → dozwolone dodatki. P: Czy muszę użyć kafla dotacji? O: Nie, jeśli jest opcjonalny; jeśli używasz — w kroku 1. P: Czy mogę zostać w tej samej lokalizacji? O: Tylko gdy reguła ruchu lub efekt na to pozwala. P: Czy przesunięcie Lativa zastępuje ruch naukowca? O: Nie — Lativa przesuwasz przy wejściu do Laboratorium, a naukowiec i tak musi tam legalnie stanąć.',
      },
    ],
  },
  {
    title: '6. Kupony',
    content: [
      {
        type: 'heading',
        text: 'Co to jest i po co istnieje',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Kupony są wyspecjalizowaną walutą akcji. Kolor lub symbol kuponu wskazuje, w której lokalizacji albo przy jakim typie czynności możesz go wydać. Dzięki temu nie finansujesz każdej akcji tym samym „uniwersalnym pieniądzem” — musisz planować, jakich kuponów potrzebujesz do kolejnych ruchów.',
      },
      {
        type: 'heading',
        text: 'Kiedy i jak wydajesz kupon',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Kupon wydajesz przy wykonaniu akcji. Nie zastępuje brakującego bota ani chemikalium. Uniwersalny kupon może zastąpić wskazany typ tylko zgodnie z ikoną. Limit przechowywania wyznacza plansza gracza i warsztat; nadwyżka przepada, jeśli efekt nie przewiduje innego rozwiązania.',
      },
      {
        type: 'heading',
        text: 'Przykład płatności',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Stoisz w R&D i chcesz wykonać badanie wymagające kuponu R&D. Oddajesz właściwy kupon i dopiero wtedy umieszczasz żeton badań. Jeżeli masz wyłącznie kupon Rządu, nie „przemalowujesz” go na R&D bez ikony uniwersalnej albo efektu, który to pozwala.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: traktowanie kuponu jak dowolnego zasobu albo trzymanie nadwyżki ponad limit warsztatu bez sprawdzenia, czy efekt chroni przed utratą.',
      },
      {
        type: 'tip',
        text: 'Wyjątek: ikona uniwersalna na kuponie albo efekcie może rozszerzyć użycie — zawsze według nadruku. Pojemność kuponów zwiększa warsztat (rozdział 7).',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Kupon opłaca legalną akcję we właściwym miejscu. P: Czy kupon zastąpi bota? O: Nie. P: Co z nadmiarem kuponów? O: Przepada przy przekroczeniu limitu, o ile efekt nie stanowi inaczej.',
      },
    ],
  },
  {
    title: '7. Warsztat, boty i chemikalia',
    content: [
      {
        type: 'heading',
        text: 'Warsztat: pojemność silnika gracza',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Warsztat kontroluje maksymalną liczbę dostępnych botów, miejsce na części, pojemność chemikaliów i kuponów oraz dodatkowe efekty i ulepszenia. Rozbudowa warsztatu to inwestycja w limity i zdolności, nie automatyczna dostawa brakujących elementów.',
      },
      {
        type: 'heading',
        text: 'Jak rozbudować warsztat',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Wybierz legalne pole warsztatu.',
          'Zapłać koszt wskazany na polu lub kaflu.',
          'Umieść kafel.',
          'Natychmiast odblokuj nową pojemność lub zdolność.',
          'Nie otrzymuj elementów automatycznie, jeśli kafel tylko zwiększa limit.',
        ],
      },
      {
        type: 'heading',
        text: 'Boty',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Bot może pracować przy eksperymencie, uczestniczyć w prototypie, zajmować pole projektu albo zostać wykorzystany przez efekt lokalizacji. Bot umieszczony na planszy nie jest dostępny w rezerwie. Wraca tylko w chwili wskazanej przez eksperyment, koniec rundy lub efekt. Konstruowanie bota zwiększa liczbę elementów, którymi dysponujesz, ale wymaga miejsca w warsztacie.',
      },
      {
        type: 'heading',
        text: 'Chemikalia',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Chemikalia mają typy i kolory. Podczas płatności używasz właściwej kombinacji; nie zamieniasz koloru bez efektu dżokera. Pobieranie i zwracanie chemikaliów może wpływać na inicjatywę lub dostępność w puli — przestrzegaj sekwencji pobrania i uzupełnienia wystawki pokazanej na planszy.',
      },
      {
        type: 'heading',
        text: 'Przykład przy Zaopatrzeniu',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Rozbudowujesz warsztat o pole zwiększające limit botów. Od tej chwili możesz mieć więcej botów, ale nowego bota dostajesz dopiero, gdy wykonasz konstrukcję bota i zapłacisz jej koszt. Później wysyłasz bota na pole eksperymentu — znika z rezerwy i nie wraca, dopóki Faza B albo ikona pola tego nie wskaże.',
      },
      {
        type: 'warning',
        text: 'Typowe błędy: traktowanie zwiększenia limitu jako natychmiastowego otrzymania zasobu oraz zabieranie bota z eksperymentu przed jego rozliczeniem.',
      },
      {
        type: 'tip',
        text: 'Odsyłacze: akcje Zaopatrzenia wykonujesz w Fazie A (rozdział 5). Wkład botów i chemikaliów w eksperyment oraz maszynę pogodową rozlicza rozdział 11. Inicjatywa związana z chemikaliami wraca w rozdziale 12.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Warsztat limituje i ulepsza; boty pracują poza rezerwą; chemikalia muszą mieć właściwy kolor. P: Czy większy limit = więcej botów od razu? O: Nie. P: Czy bot wraca zaraz po umieszczeniu? O: Nie — wraca według pola lub fazy eksperymentu.',
      },
    ],
  },
  {
    title: '8. Rząd: części, dotacje i finansowanie',
    content: [
      {
        type: 'heading',
        text: 'Po co istnieje Rząd',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Rząd zamienia część maszyny i spełnione warunki w nagrody, finansowanie oraz kafle dotacji. To także jeden z obszarów, którego zapełnienie może uruchomić sygnał końca gry — dlatego sprzedaż części nie jest tylko „zbieraniem punktów po drodze”.',
      },
      {
        type: 'heading',
        text: 'Sprzedaż części maszyny',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Wybierz dostępne zlecenie lub pole.',
          'Oddaj wymagane części.',
          'Umieść swój znacznik lub bota, jeśli wymaga tego pole.',
          'Odbierz wskazaną nagrodę.',
          'Przesuń odpowiedni tor finansowania.',
        ],
      },
      {
        type: 'heading',
        text: 'Dotacja',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Dotacja daje jednorazową albo trwałą korzyść, ale wymaga spełnienia warunku. Przy każdym kaflu sprawdzasz: moment użycia, koszt, czy kafel się odwraca oraz czy działa w tej samej turze, w której został zdobyty. Katalog konkretnych efektów odczytujesz z kafla — aplikacja nie wymyśla brakujących tekstów.',
      },
      {
        type: 'heading',
        text: 'Przykład sprzedaży',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Masz wymagane części i stoisz w Rządzie. Wybierasz wolne zlecenie, oddajesz części, kładziesz znacznik jeśli pole tego wymaga, bierzesz nagrodę z ikon i przesuwasz finansowanie. Jeśli to zajęcie zapełnia obszar Rządu wyzwalający koniec, oznaczacie sygnał i przygotowujecie procedurę dokończenia — nie kontynuujecie jakby nic się nie stało.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: pomijanie przesunięcia toru finansowania albo używanie kafla dotacji poza dozwolonym momentem tury.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: kafle Dotacji/Inwestycji w kroku 1 tury opisuje rozdział 5. Sygnały końca — rozdział 13. Konkretne wartości nagród: nadruk na polu lub kaflu.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Rząd: sprzedaż części, dotacje, finansowanie, możliwy trigger końca. P: Czy dotacja zawsze działa od razu? O: Tylko jeśli kafel na to pozwala. P: Czy zapełnienie Rządu kończy grę natychmiast? O: Uruchamia sygnał; potem procedura dokończenia.',
      },
    ],
  },
  {
    title: '9. Laboratorium Lativa: eksperyment, publikacja, cytowanie',
    content: [
      {
        type: 'heading',
        text: 'Rola Laboratorium',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Laboratorium Lativa jest głównym miejscem przygotowywania i wspierania eksperymentów oraz publikowania wyników. Tu zostawiasz wkład, który Faza B może rozliczyć wspólnie. Publikacje i cytowania łączą indywidualny postęp badań ze wspólną planszą.',
      },
      {
        type: 'heading',
        text: 'Praca nad eksperymentem',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Wybierz aktywny typ pogody lub gałąź. Umieść wymagane boty i chemikalia. Zdobądź wkład lub bonus pola. Oznacz swoje uczestnictwo. Nie odzyskuj elementów do chwili rozliczenia, jeśli plansza tak wskazuje. Możesz przygotować wkład nawet wtedy, gdy eksperyment nie uruchomi się w tej rundzie — o ile pole i stan planszy na to pozwalają; elementy pozostają zgodnie z zasadami pola.',
      },
      {
        type: 'heading',
        text: 'Publikacja',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Publikacja wymaga odpowiednich badań lub tomów i często powiązania z przeprowadzonym eksperymentem. Po opublikowaniu zdobywasz punkty i nagrody, umieszczasz znacznik i udostępniasz innym możliwość cytowania. Nie publikujesz „na kredyt” — najpierw spełnij wszystkie wymagane badania.',
      },
      {
        type: 'heading',
        text: 'Cytowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Cytujący korzysta z cudzej publikacji, a autor otrzymuje rekompensatę. Dokładne koszty i punkty muszą być odczytane z danych publikacji na komponencie; nie zgaduj ich.',
      },
      {
        type: 'heading',
        text: 'Przykład wkładu',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Aktywna jest gałąź burzy. Kładziesz bota i właściwe chemikalia na wolne wymagane pole, bierzesz bonus pola i zostawiasz znacznik uczestnictwa. W Fazie B, jeśli wszystkie warunki eksperymentu są spełnione, rozliczacie efekt; twój bot wraca dopiero wtedy, gdy ikony tak wskażą — nie ściągasz go „bo już położyłem”.',
      },
      {
        type: 'warning',
        text: 'Typowe błędy: publikowanie bez wszystkich badań oraz zabieranie wkładu z eksperymentu przed rozliczeniem Fazy B.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: warunki uruchomienia i kolejność rozliczenia eksperymentu oraz maszyny pogodowej — rozdział 11. Badania potrzebne do publikacji zdobywasz w R&D (rozdział 10).',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Laboratorium: wkład w eksperyment, publikacje, cytowania. P: Czy można przygotować eksperyment, który nie odpali w tej rundzie? O: Tak, jeśli pole na to pozwala. P: Czy cytowanie płaci autorowi? O: Tak — autor dostaje rekompensatę według danych publikacji.',
      },
    ],
  },
  {
    title: '10. R&D: badanie, przełom, prototyp',
    content: [
      {
        type: 'heading',
        text: 'Po co istnieje R&D',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Badania i Rozwój budują przewagę naukową: żetony badań otwierają publikacje, prototypy i lepszą pozycję w eksperymentach. Przełom jest silniejszym etapem rozwoju. Zapełnienie odpowiedniego obszaru R&D może uruchomić sygnał końca gry.',
      },
      {
        type: 'heading',
        text: 'Badanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Wybierz dziedzinę, zapłać koszt i umieść lub zdobądź żeton badań. Badania są wymagane przez prototypy, publikacje i eksperymenty — traktuj je jak klucze, nie jak ozdobne żetony.',
      },
      {
        type: 'heading',
        text: 'Przełom',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Przełom może odblokować nowy efekt, miejsce prototypu, punkty albo przewagę w eksperymencie. Konkretny efekt odczytujesz z toru lub kafla — bez zgadywania.',
      },
      {
        type: 'heading',
        text: 'Prototyp',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Wybierz dostępny prototyp.',
          'Spełnij wymagania badań.',
          'Dostarcz części, boty i chemikalia.',
          'Umieść znacznik.',
          'Odbierz efekt i punkty wskazane na planie prototypu.',
        ],
      },
      {
        type: 'heading',
        text: 'Przykład ścieżki do prototypu',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Najpierw w R&D wykonujesz badanie i kładziesz żeton w wymaganej dziedzinie. W kolejnej turze wracasz z częściami, botem i chemikaliami, wybierasz prototyp spełniający wymagania i domykasz go znacznikiem. Nagrodę bierzesz tylko w zakresie nadruku planu — nie dopisujesz punktów „za trud”.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: budowa prototypu bez kompletnych badań albo mylenie prototypu (indywidualnego) z eksperymentem (wspólnym w Fazie B).',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: publikacje oparte na badaniach — rozdział 9. Trigger zapełnienia R&D — rozdział 13. Efekty konkretnych prototypów: komponenty przy stole.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'R&D: badanie → przełom/prototyp → możliwy trigger końca. P: Czy prototyp rozlicza się w Fazie B? O: Prototyp to indywidualne osiągnięcie w R&D; wspólny eksperyment to Faza B. P: Czy przełom zawsze daje punkty? O: Tylko jeśli tak wskazują ikony lub kafel.',
      },
    ],
  },
  {
    title: '11. Maszyna pogodowa i Faza B — eksperyment',
    content: [
      {
        type: 'heading',
        text: 'Czym jest maszyna pogodowa',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Maszyna pogodowa to wspólny silnik partii: łączy regiony, typy pogody i aktywną gałąź eksperymentu. Nie jest osobną „planszą gracza” — wszyscy patrzą na ten sam stan maszyny. W turach przygotowujecie wkład w Laboratorium pod aktualną gałąź; w Fazie B sprawdzacie, czy maszyna w ogóle może odpalić eksperyment, a potem rozpatrujecie efekt maszyny według ikon i planu.',
      },
      {
        type: 'heading',
        text: 'Regiony, typy pogody i aktywna gałąź',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Przy przygotowaniu ustawiacie maszynę pogodową, regiony oraz typy pogody. W trakcie gry znaczniki pogody i asystent albo znacznik aktywnej gałęzi pokazują, która gałąź jest aktualnie rozliczana. Nie zgadujecie „która pogoda pasuje” z pamięci — odczytujecie aktywny typ i gałąź z komponentów na stole. Wkład botów i chemikaliów w Laboratorium musi pasować do aktywnej gałęzi; wkład pod inną pogodę nie zastępuje braków na wymaganych polach bieżącego eksperymentu.',
      },
      {
        type: 'heading',
        text: 'Lativ, asystent i warunki maszyny',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Profesor Lativ i asystent są częścią warunków uruchomienia. Po wejściu naukowca do Laboratorium możesz przesunąć Lativa zgodnie z regułą lokalizacji — to narzędzie ustawiania warunków, nie ozdoba. W Fazie B eksperyment startuje tylko wtedy, gdy asystent lub Lativ stoi we właściwym miejscu, dostępny jest właściwy eksperyment, wymagane pola mają wkład i nie blokuje was szczególna reguła. Brak pozycji figury = brak efektu maszyny, nawet jeśli gracze „prawie” domknęli pola.',
      },
      {
        type: 'heading',
        text: 'Kiedy sprawdzacie eksperyment',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Po zakończeniu tur wszystkich graczy sprawdzacie aktywną gałąź maszyny pogodowej. Eksperyment uruchamia się tylko wtedy, gdy spełniono wszystkie wymagane warunki: wymagane pola mają wkład, dostępny jest właściwy eksperyment, asystent lub Lativ znajduje się we właściwym miejscu i nie blokuje go szczególna reguła. Brak któregokolwiek warunku oznacza, że eksperyment nie działa — nie wypłacacie częściowych nagród.',
      },
      {
        type: 'heading',
        text: 'Kolejność rozpatrywania',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Potwierdź typ pogody i aktywną gałąź maszyny.',
          'Sprawdź wkład graczy na wymaganych polach.',
          'Rozpatrz efekt maszyny według planu i ikon.',
          'Przyznaj nagrody i punkty wyłącznie przy pełnym uruchomieniu.',
          'Zwróć lub przesuń boty i chemikalia zgodnie z ikonami.',
          'Zaktualizuj tory i wystawki.',
          'Przenieś asystenta lub znacznik aktywnej gałęzi.',
        ],
      },
      {
        type: 'heading',
        text: 'Przykład nieudanego uruchomienia',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Dwoje graczy dołożyło wkład pod aktywną gałąź burzy, ale asystent nie stoi w wymaganym miejscu maszyny. Faza B kończy się bez efektu maszyny i bez nagród. Wkład pozostaje tak, jak wskazują pola — nie „wyrównujecie” sytuacji wypłatą połowy punktów ani ręcznym przestawieniem asystenta „bo przecież prawie”.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: wypłacanie częściowej nagrody za nieuruchomiony eksperyment, ściąganie botów przed rozliczeniem ikon zwrotu albo ignorowanie pozycji Lativa/asystenta przy ocenie warunków maszyny.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: przygotowanie wkładu w Laboratorium — rozdział 9; setup maszyny, regionów i typów pogody — rozdział 4. Po Fazie B następuje Faza C (rozdział 12). Konkretne efekty pogody i koszty ikon: plany oraz komponenty przy stole — bez zgadywania.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Maszyna pogodowa: wspólny stan regionów, typów pogody i gałęzi; Faza B = wszystkie warunki albo zero nagród. P: Czy jeden brakujący bot blokuje całość? O: Tak, jeśli pole jest wymagane. P: Czy można domknąć warunki w Fazie B nową akcją? O: Nie — warunki oceniacie po turach graczy. P: Czy efekt maszyny wolno odczytać „z pamięci”? O: Nie — z planu i ikon aktywnej gałęzi.',
      },
    ],
  },
  {
    title: '12. Faza C i inicjatywa',
    content: [
      {
        type: 'heading',
        text: 'Co domykasz na końcu rundy',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Faza C porządkuje stół przed następną rundą: odświeżasz wskazane kafle, uzupełniasz wystawki, przesuwasz znaczniki pogody i rundy, ustalasz inicjatywę, sprawdzasz sygnały końca gry i przygotowujesz kolejną rundę. Pominięcie któregoś kroku psuje kolejność tur albo dostępność kafli.',
      },
      {
        type: 'step-list',
        steps: [
          'Odśwież wskazane kafle.',
          'Uzupełnij wystawki.',
          'Przesuń znaczniki pogody i rundy.',
          'Ustal inicjatywę.',
          'Sprawdź sygnały końca gry.',
          'Przygotuj kolejną rundę.',
        ],
      },
      {
        type: 'heading',
        text: 'Inicjatywa',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Tor inicjatywy decyduje o kolejności graczy. Nie zawsze wygrywa osoba, która pierwsza dotarła na pole — stosuj regułę nakładania znaczników opisaną na torze. Każde źródło zmiany inicjatywy (w tym efekty związane z chemikaliami lub akcjami Zaopatrzenia) powinno być rozpatrywane w momencie wskazanym przez efekt, a wynik końcowy kolejności domykacie w Fazie C.',
      },
      {
        type: 'heading',
        text: 'Przykład kolejności',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Dwoje graczy zajmuje to samo pole inicjatywy w różnym momencie rundy. Przy ustalaniu kolejności stosujecie regułę nakładania znaczników z toru — nie głosujecie „kto pierwszy krzyknął”. Nowa kolejność obowiązuje od następnej Fazy A, o ile procedura nie stanowi inaczej.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: pomijanie kolejności inicjatywy i granie „w stałej kolejności od początku partii” mimo przesunięć na torze.',
      },
      {
        type: 'tip',
        text: 'Odsyłacz: sygnały końca sprawdzane w Fazie C prowadzi rozdział 13. Ruch po chemikaliach może wpływać na inicjatywę — rozdział 7. Maszyna pogodowa i Faza B — rozdział 11.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Faza C: odświeżenie, wystawki, pogoda, inicjatywa, triggery, przygotowanie. P: Czy inicjatywę liczy się „na oko”? O: Nie — według toru i nakładania znaczników. P: Czy Faza C jest przed Fazą B? O: Nie; kolejność to A → B → C.',
      },
    ],
  },
  {
    title: '13. Sygnały końca gry i Punktowanie',
    content: [
      {
        type: 'heading',
        text: 'Kiedy pojawia się sygnał końca',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Koniec może zostać uruchomiony, gdy przyznano Nagrodę Nobla, gdy odpowiedni obszar Rządu został zapełniony, gdy odpowiedni obszar R&D został zapełniony albo gdy zabrakło kolejnych kafli eksperymentów. Po sygnale wykonujecie dokładnie liczbę tur lub rund wskazaną w oficjalnej procedurze dokończenia — nie kończycie w połowie tury „bo padł trigger”.',
      },
      {
        type: 'warning',
        text: '[DO WERYFIKACJI] Kolejność dokończenia dla każdego triggera wymaga potwierdzenia względem polskiego wydania. Nie zastępuj jej domysłem.',
      },
      {
        type: 'heading',
        text: 'Co punktujesz',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Punkty klimatu można zdobywać za eksperymenty, prototypy, publikacje, cytowania, pozycje na torach, dotacje i inwestycje, cele, rozwinięty warsztat oraz pozostałe elementy wskazane ikonami końcowymi. W aplikacji ten sam zestaw kategorii zasila zasady, Quick Reference i kalkulator — ale konkretne wartości ikon nadal pochodzą z komponentów.',
      },
      {
        type: 'heading',
        text: 'Przykład zamknięcia',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Zapełnia się obszar Rządu wyzwalający koniec. Oznaczacie sygnał, dokańczacie wymaganą procedurę (gdy będzie zweryfikowana co do liczby tur/rund), a dopiero potem sumujecie punkty ze wszystkich legalnych źródeł. Nie wyrzucacie niedokończonych wkładów „poza punktacją”, jeśli ikony końca nakazują je policzyć — i nie dopisujecie kategorii spoza listy.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd: mylenie sygnału końca z natychmiastowym przerwaniem gry oraz pomijanie kategorii punktowanych tylko ikonami końcowymi.',
      },
      {
        type: 'tip',
        text: 'Granica źródeł: bez polskiego katalogu wartości ikon aplikacja pozostaje PARTIAL dla pełnego kalkulatora. Procedury lokalizacji i faz są opisane; liczby na kaflach — przy stole.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Sygnał → procedura dokończenia → punktowanie końcowe. P: Czy Nobel kończy natychmiast? O: Uruchamia sygnał; potem oficjalne dokończenie. P: Czy warsztat punktuje? O: Tak, jeśli ikony końcowe tak wskazują.',
      },
    ],
  },
  {
    title: '14. Pierwsza partia i QUICK REFERENCE',
    content: [
      {
        type: 'heading',
        text: 'Jak uczyć pierwszą partię',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Najpierw wyjaśnij tylko cztery lokalizacje i trzy fazy rundy. Pokaż, że naukowiec wskazuje miejsce wykonania akcji. W pierwszej rundzie każdy powinien rozbudować warsztat albo zbudować bota, żeby poczuć Zaopatrzenie. Przed pierwszym eksperymentem wspólnie sprawdźcie wszystkie wymagania Fazy B. Publikacje i cytowania omówcie dopiero, gdy ktoś ma wymagane badania. Korzystajcie z Guided i checklisty elementów pozostawionych przy eksperymencie.',
      },
      {
        type: 'heading',
        text: 'QUICK REFERENCE — skrót stołowy',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Runda: A — opcjonalny kafel → podróż naukowca → akcja lokalizacji → akcje dodatkowe; B — sprawdzenie maszyny pogodowej i uruchomienie eksperymentu; C — odświeżenie, inicjatywa, triggery końca. Lokalizacje: Zaopatrzenie (warsztat, bot, inicjatywa, chemikalia); Rząd (części, dotacje); Laboratorium (eksperyment, publikacja, cytowanie); R&D (badanie, przełom, prototyp). Maszyna: regiony + typy pogody + aktywna gałąź + Lativ/asystent.',
      },
      {
        type: 'warning',
        text: 'Typowy błąd pierwszej partii: uczenie od razu publikacji i cytowań, zanim stół rozumie ruch naukowca i Fazę B.',
      },
      {
        type: 'tip',
        text: 'Odsyłacze: pełna tura i podróż — rozdział 5; maszyna pogodowa i eksperyment — 11; koniec i punktowanie — 13. Guided kroki są w firstGameSteps.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Pierwsza partia uczy lokalizacji, tur i eksperymentu przed publikacjami. P: Od czego zacząć rundę 1? O: Od warsztatu lub bota. P: Kiedy uczyć cytowań? O: Gdy ktoś ma badania do publikacji.',
      },
    ],
  },
  {
    title: 'NAJCZĘSTSZE BŁĘDY',
    content: [
      {
        type: 'heading',
        text: 'Błędy, które psują partię',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Najczęściej stół psuje się tymi samymi skrótami myślowymi. Traktowanie zwiększenia limitu warsztatu jako natychmiastowego otrzymania zasobu zostawia gracza bez botów, których „myślał, że dostał”. Zabieranie bota z eksperymentu przed rozliczeniem kasuje wkład potrzebny w Fazie B. Używanie kuponu jako dowolnego zasobu omija wymagania materiałowe. Wypłacanie częściowej nagrody za nieuruchomiony eksperyment łamie regułę „wszystko albo nic”. Pomijanie kolejności inicjatywy psuje tor tur. Publikowanie bez wszystkich badań otwiera nielegalne cytowania. Mylenie sygnału końca z natychmiastowym przerwaniem gry ucina legalne dokończenie.',
      },
      {
        type: 'heading',
        text: 'Trzy pytania przed Fazą B',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Czy każde wymagane pole ma wkład?',
          'Czy asystent/Lativ stoi tam, gdzie trzeba, i czy jest właściwy eksperyment?',
          'Czy jesteście gotowi nie wypłacać nic, jeśli brakuje jednego warunku?',
        ],
      },
      {
        type: 'heading',
        text: 'Trzy pytania po rozbudowie warsztatu',
        level: 2,
      },
      {
        type: 'step-list',
        steps: [
          'Czy odblokowaliście tylko limit/zdolność, czy efekt naprawdę dodaje elementy?',
          'Czy macie miejsce na nowego bota, zanim go skonstruujecie?',
          'Czy kuponów i chemikaliów nie trzymacie ponad limitem?',
        ],
      },
      {
        type: 'warning',
        text: 'Granica kompletności: brak lokalnego katalogu ikon kosztów/nagród oraz dokładnych liczb setupu 2/3/4 i procedur dokończenia per trigger. Status treści pozostaje partial.',
      },
      {
        type: 'tip',
        text: 'Ta instrukcja jest ukończonym nauczaniem procedur w granicy lokalnego szkicu. Zielony test nie oznacza, że ikony na kaflach zostały przepisane.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Limit ≠ dostawa; wkład zostaje do rozliczenia; kupon ≠ bot; eksperyment bez warunków = zero nagród. P: Czy aplikacja zna każdy koszt ikony? O: Nie. P: Czy wolno domyślać dokończenie po Nobel? O: Nie — oznaczone do weryfikacji.',
      },
    ],
  },
  {
    title: 'FAQ',
    content: [
      {
        type: 'heading',
        text: 'Najczęstsze pytania przy stole',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Czy muszę użyć kafla dotacji na początku tury? Nie, jeśli jest opcjonalny. Jeśli go używasz, zrób to w określonym kroku (krok 1 Fazy A).',
      },
      {
        type: 'paragraph',
        text: 'Czy mogę pozostać w tej samej lokalizacji? Tylko gdy reguła ruchu albo efekt specjalny na to pozwala.',
      },
      {
        type: 'paragraph',
        text: 'Czy bot wraca od razu po umieszczeniu? Nie. Wraca w chwili wskazanej przez pole lub fazę eksperymentu.',
      },
      {
        type: 'paragraph',
        text: 'Czy można przygotować eksperyment, który nie uruchomi się w tej rundzie? Tak, jeśli pole i aktualny stan planszy na to pozwalają; elementy pozostają zgodnie z zasadami.',
      },
      {
        type: 'paragraph',
        text: 'Czy trigger końca kończy grę natychmiast? Nie. Najpierw wykonuje się oficjalną procedurę dokończenia.',
      },
      {
        type: 'paragraph',
        text: 'Czy kupon zastępuje chemikalium? Nie, chyba że ikona uniwersalna lub efekt wyraźnie na to pozwala.',
      },
      {
        type: 'paragraph',
        text: 'Czy zwiększenie limitu warsztatu daje od razu bota? Nie — najpierw odblokowujesz pojemność, potem konstruujesz bota osobną akcją.',
      },
      {
        type: 'paragraph',
        text: 'Czym jest maszyna pogodowa względem eksperymentu? Maszyna to wspólny stan regionów, typów pogody i aktywnej gałęzi; eksperyment to rozliczenie Fazy B, gdy wszystkie warunki maszyny i wkładu są spełnione.',
      },
      {
        type: 'paragraph',
        text: 'Czy podróż naukowca jest obowiązkowa co turę? Musisz rozliczyć krok ruchu zgodnie z regułami — w tym legalne pozostanie, jeśli plansza lub efekt na to pozwala. Bez legalnej pozycji naukowca nie wykonujesz akcji lokalizacji.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'FAQ domyka spory proceduralne bez zgadywania wartości ikon. Szczegóły lokalizacji, podróży, maszyny i faz: rozdziały 5–13.',
      },
    ],
  },
  {
    title: 'GLOSSARY',
    content: [
      {
        type: 'heading',
        text: 'Słownik pojęć',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Eksperyment — wspólny projekt uruchamiany w Fazie B po spełnieniu wszystkich warunków maszyny pogodowej. Maszyna pogodowa — wspólny silnik regionów, typów pogody i aktywnej gałęzi; nie należy do jednego gracza. Podróż — legalny ruch (lub legalne pozostanie) naukowca, który otwiera akcję lokalizacji. Prototyp — indywidualne osiągnięcie tworzone w R&D. Publikacja — naukowy wynik pozwalający zdobywać punkty i cytowania. Cytowanie — skorzystanie z cudzej publikacji z rekompensatą dla autora. Kupon — wyspecjalizowany koszt akcji. Bot — pracownik umieszczany na projektach; poza rezerwą, dopóki nie wróci. Warsztat — plansza pojemności i silnika gracza. Chemikalia — zasoby kolorów/typów wymagane przez projekty. Inicjatywa — kolejność tur w rundzie według toru i nakładania znaczników. Lativ / asystent — figury warunkujące i prowadzące maszynę pogodową. Sygnał końca — warunek uruchamiający procedurę dokończenia, nie natychmiastowe zerwanie stołu.',
      },
      {
        type: 'heading',
        text: 'Podsumowanie i mikro-FAQ',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Słownik rozróżnia wspólny eksperyment od indywidualnego prototypu oraz sygnał końca od natychmiastowego stopu. P: Czy publikacja = cytowanie? O: Nie; cytowanie korzysta z już opublikowanego wyniku. P: Czy inicjatywa = pierwszy gracz z setupu na zawsze? O: Nie — tor może zmienić kolejność. P: Czy maszyna pogodowa to plansza jednego gracza? O: Nie — to wspólny stan regionów, typów pogody i aktywnej gałęzi.',
      },
    ],
  },
];

export const weatherMachineFirstGame: FirstGameStep[] = [
  {
    id: 1,
    title: 'Pokaż mapę decyzji',
    content: [
      'Wskaż cztery lokalizacje: Zaopatrzenie, Rząd, Laboratorium Lativa, R&D.',
      'Opisz trzy fazy rundy: A tury, B eksperyment maszyny pogodowej, C koniec rundy.',
    ],
    why: 'Bez mapy lokalizacji i faz stół nie wie, kiedy wolno działać, a kiedy tylko rozliczać.',
    commonMistake: 'Uczenie od razu publikacji zamiast lokalizacji i faz.',
    chapterIndex: 1,
  },
  {
    id: 2,
    title: 'Naukowiec i podróż',
    content: [
      'Połóż naukowca w jednej lokalizacji i pokaż legalną podróż do innej.',
      'Pokaż, że akcję lokalizacji wykonuje się tylko tam, gdzie naukowiec stoi po ruchu.',
    ],
    why: 'Podróż naukowca jest bramką legalności akcji.',
    commonMistake: 'Wykonywanie akcji „z ręki” w lokalizacji bez legalnego ruchu naukowca.',
    chapterIndex: 4,
  },
  {
    id: 3,
    title: 'Pierwsza runda: warsztat lub bot',
    content: [
      'Każdy gracz w rundzie 1 rozbudowuje warsztat albo konstruuje bota.',
      'Sprawdźcie, że zwiększenie limitu nie dodaje automatycznie zasobów.',
    ],
    why: 'Uczy Zaopatrzenia i różnicy między limitem a dostawą.',
    commonMistake: 'Traktowanie większego limitu jak natychmiastowych botów.',
    chapterIndex: 6,
  },
  {
    id: 4,
    title: 'Checklista przed Fazą B i maszyną',
    content: [
      'Wspólnie sprawdźcie aktywną gałąź pogody, wkład, właściwy eksperyment oraz pozycję asystenta/Lativa.',
      'Ustalcie, że brak jednego warunku maszyny oznacza zero nagród.',
    ],
    why: 'Chroni przed częściowymi wypłatami i ściąganiem botów za wcześnie.',
    commonMistake: 'Wypłacanie częściowej nagrody albo zabieranie wkładu przed rozliczeniem.',
    chapterIndex: 10,
  },
  {
    id: 5,
    title: 'Publikacje dopiero z badaniami',
    content: [
      'Odłóżcie omówienie publikacji i cytowań, aż ktoś ma wymagane badania.',
      'Pokażcie wtedy ścieżkę: badania → publikacja → możliwe cytowanie.',
    ],
    why: 'Zmniejsza przeciążenie pierwszej partii i blokuje nielegalne publikacje.',
    commonMistake: 'Publikowanie bez spełnienia wszystkich badań.',
    chapterIndex: 8,
  },
  {
    id: 6,
    title: 'Guided: elementy przy eksperymencie',
    content: [
      'Użyjcie checklisty elementów pozostawionych przy eksperymencie maszyny pogodowej.',
      'Dopiero po Fazie B przesuwajcie boty, chemikalia oraz asystenta/znacznik gałęzi według ikon.',
    ],
    why: 'Utrwala, że wkład zostaje do rozliczenia wspólnego eksperymentu maszyny.',
    commonMistake: 'Sprzątanie pól eksperymentu w środku czyjejś tury.',
    chapterIndex: 10,
  },
];
